var render = function render(){var _vm=this,_c=_vm._self._c;return _c('chooser',{staticClass:"motivation-chooser",attrs:{"options":_vm.schemeOptions,"title":"What is your main priority?"},on:{"input":_vm.onInput},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }